<template>
	<div @click="$emit('click')" :class="['card-text',disabled?'disabled':'enable']">
		<!-- <img :src="img" v-if="img != ''" /> -->
		<b>{{ tip }}</b>
		<br><br>
		<p style="font-size:12px;">{{ title }}</p>
	</div>
</template>

<script>
export default {
    props:{
        title:{},
        tip:{},
        img:{
            default:''
        },
        disabled:{
            default:false
        }
    }
};
</script>

<style lang="less" scoped>
	.card-text{
		height: 244px;
		border-radius: 5px;
		cursor: not-allowed;
		text-align: center;
		padding: 0 10px;
		padding-top: 50px;
		box-sizing: border-box;
		font-size: 18px;
		line-height: 25px;
		background-color: #18a1fd;
		color: #ffffff;
	}
	
	.enable{
		box-shadow: 2px 2px 4px 1px #e7e1e1;
	}
	.enable{
		cursor: pointer;
		&:hover{
			box-shadow: 0px 4px 4px 1px rgba(24,161,253,0.15);
			transform: scale(1.05)
		}
	}
	.disabled{
		box-shadow: 2px 2px 4px 1px #e7e1e1;
	}
</style>